import { keys } from './keys';

export const es = {
  [keys.share]: 'Compartir',
};
